var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3DA010"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.91C15.4142 24.91 15.75 24.5742 15.75 24.16C15.75 23.7458 15.4142 23.41 15 23.41C14.5858 23.41 14.25 23.7458 14.25 24.16C14.25 24.5742 14.5858 24.91 15 24.91Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.71 27.9H24.76C25.85 27.9 26.78 27.13 26.98 26.06C27.28 24.52 27.64 22.08 27.72 19.22C27.73 18.74 27.55 18.28 27.22 17.94C26.89 17.6 26.45 17.41 25.97 17.41H23.73V14.16C23.73 13.05 23.38 12.23 22.69 11.73C21.53 10.89 19.93 11.39 19.75 11.45C19.45 11.55 19.24 11.84 19.24 12.16V15.85L17.68 17.41H16.99L16.987 17.41H13C12.59 17.41 12.25 17.75 12.25 18.16V26.16C12.25 26.57 12.59 26.91 13 26.91H16.851C17.3884 27.0678 19.9982 27.7824 24.71 27.9ZM16.24 18.91V25.41H13.75V18.91H16.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpSelected);
export default __webpack_public_path__ + "static/media/thumbs_up_selected.f2e8dff53e2b33e0546c72b4e2376c59.svg";
export { ForwardRef as ReactComponent };